import { useTranslation } from 'react-i18next';
import '../../assets/Global.css';
export const Table = ({ columnNames, data }: { columnNames: string[]; data: { name: string; minPrice: number }[] }) => {
  return (
    <TableBase
      columnNames={columnNames}
      element={data.map((item, index) => (
        <tr key={index}>
          <td>{item.name}</td>
          <td>{item.minPrice.toFixed(2) + ' €'}</td>
        </tr>
      ))}
    />
  );
};

export const TableWithIntervalPrices = ({
  columnNames,
  data,
}: {
  columnNames: string[];
  data: { name: string; minPrice: number; maxPrice?: number }[];
}) => {
  return (
    <TableBase
      columnNames={columnNames}
      element={data.map((item, index) => (
        <tr key={index}>
          <td>{item.name}</td>
          <td>
            {item.minPrice.toFixed(2)}€{item.maxPrice ? ' a ' + item.maxPrice.toFixed(2) + '€' : ''}
          </td>
        </tr>
      ))}
    />
  );
};

export const TableWithIntervalQuantities = ({
  columnNames,
  data,
}: {
  columnNames: string[];
  data: { minQuantity: number; maxQuantity?: number; price: number }[];
}) => {
  const { t } = useTranslation();
  return (
    <TableBase
      columnNames={columnNames}
      element={data.map((item, index) => (
        <tr key={index}>
          <td>
            {item.maxQuantity !== undefined ? t("table.minMaxQuantities", { minQuantity: item.minQuantity, maxQuantity: item.maxQuantity }) : t("table.minQuantities", { minQuantity: item.minQuantity })}
          </td>
          <td>{item.price.toFixed(2) + ' €'}</td>
        </tr>
      ))}
    />
  );
};

export const TableWithUnits = ({
  columnNames,
  data,
}: {
  columnNames: string[];
  data: { name: string; minPrice: number; unit?: string }[];
}) => {
  return (
    <TableBase
      columnNames={columnNames}
      element={data.map((item, index) => (
        <tr key={index}>
          <td>{item.name}</td>
          <td>{item.minPrice.toFixed(2) + "€" + (item.unit ? (' / ' + item.unit) : "")}</td>
        </tr>
      ))}
    />
  );
};

const TableBase = ({ columnNames, element }: { columnNames: string[]; element: React.ReactNode }) => {
  return (
    <table>
      <thead>
        <tr>
          {columnNames.map((name, index) => (
            <th key={index}>{name}</th>
          ))}
        </tr>
      </thead>
      <tbody>{element}</tbody>
    </table>
  );
};
